import script from "./StudentHoursTab.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentHoursTab.vue?vue&type=script&setup=true&lang=js"

import "./StudentHoursTab.vue?vue&type=style&index=0&id=41063a15&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41063a15"]])

export default __exports__